import { Button } from '@vlabs/uikit/components/controls/button';
import { useTranslation } from 'react-i18next';

import { filterIsApplied, FilterMenu } from '@vlabs/monokit/shared/ui/filter-menu';

import { DateFilterWithLeftPopover, UserIdFilterWithLeftPopover } from './side-menu';
import { usePermissionTagsFilters } from './usePermissionTagsFilters';

export function PermissionTagListFilterMenu(): JSX.Element {
  const { t } = useTranslation();
  const { filters, setFilters } = usePermissionTagsFilters();

  const isResetDisabled = Object.values(filters).filter(Boolean).length === 0;

  return (
    <FilterMenu
      filters={[<UserIdFilterWithLeftPopover
        badge={filterIsApplied(!!filters.created_by_user)}
        key="user_login"
        value={t('entities:permission_tags_filters.created_by_user.menu_item_title')}
      />, <DateFilterWithLeftPopover
        badge={filterIsApplied(!!(filters.create_time__lt ?? filters.create_time__gte))}
        key="create_time"
        value={t('entities:permission_tags_filters.create_time.menu_item_title')}
      />]}
      footer={(
        <Button
          data-testid="button.reset-permission-tags-filters"
          disabled={isResetDisabled}
          fullWidth
          kind="negative"
          onClick={() => setFilters({
            page: 1,
            page_size: 25,
          })}
        >
          {t('entities:permission_tags_filters.reset.label')}
        </Button>
      )}
    />
  );
}
